import { useEffect, useState } from 'react'
import { useDebounce } from '@/shared/hooks/useDebounceHook'
import { SearchResultType } from '@/types/search/searchResultType'
import { debounceSpeedMedium } from '@/shared/constants/appConstants'
import { getSearchService } from '@/shared/getContainer/getSearchService'

const searchService = await getSearchService()

export const useSearchResult = (query: string) => {
    const [resultsArray, setResultsArray] = useState<Array<SearchResultType>>(
        []
    )
    const service = searchService()

    const debouncedValue = useDebounce(query, debounceSpeedMedium)
    const getResults = async () => {
        const response = await service.getSearchResults(query)

        if (response) {
            const responseArray = response.searchResults

            setResultsArray(responseArray)
        }
    }

    useEffect(() => {
        setResultsArray([])
        getResults()
    }, [debouncedValue])

    return resultsArray
}
